import React from 'react';
import { Link } from 'react-router-dom';

export const SiteFooter: React.FC = () => (
  <div className="guest-site">
    <footer className="site-footer minimal-footer">
      <div className="container minimal-footer-line">
        <span>&copy; {new Date().getFullYear()} Armadillo Hotel. All rights reserved.</span>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
      </div>
    </footer>
  </div>
);
